import { NO_ANALYTICS } from "@highmarch/app";
import type { Analytics } from "@highmarch/app";
import { CHANNEL } from "../../boot/channel";
import { runningBuild } from "../buildWatcher";
import { isNativeShell } from "../platform/shell";
import { BeaconAnalytics, browserBeaconEnv } from "./beaconAnalytics";
import { InstallStats, startSession } from "./installStats";

/** The game's analytics and this session's install facts, chosen once (ADR 0015). */
export interface AnalyticsSetup { readonly analytics: Analytics; readonly install: InstallStats }

/**
 * Only the Cloudflare Pages builds (beta, public) report — they are the ones with a receiver at `/api/e`. Local builds
 * (the Mac, the tunnel, dev), automation and the iOS app send nothing.
 */
export function openAnalytics(): AnalyticsSetup {
  if (typeof window === "undefined" || typeof document === "undefined") return { analytics: NO_ANALYTICS, install: { id: "", days: 0, sessions: 1 } };
  const store = (() => { try { return globalThis.localStorage ?? null; } catch { return null; } })();
  const install = startSession(store, Date.now(), () => crypto.randomUUID());
  const reports = CHANNEL !== "local" && !isNativeShell() && !navigator.webdriver;
  const analytics = reports ? new BeaconAnalytics(install.id, CHANNEL, runningBuild() ?? "dev", browserBeaconEnv) : NO_ANALYTICS;
  return { analytics, install };
}
